import KitBuilderBase from "@/components/KitBuilderBase";
import { CABLING_KIT } from "@/kitConfigs";

export default function KitBuilder() {
  return <KitBuilderBase config={CABLING_KIT} />;
}
